(ns frontend.view.grid.counterparty-diligence-grid.company.columns)

;;default set of selected columns
(def ordered-default-columns
  [:company-counterparty-diligence/company-name
   :counterparty-diligence/status
   :company-counterparty-diligence/template
   :counterparty-diligence/note
   :company-counterparty-diligence/screening-status])

(def default-columns
  (set ordered-default-columns))

;;always selected:
(def mandatory?
  #{:company-counterparty-diligence/company-name})
